import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  orderTagFromModel,
  validateOrderTagCondition,
  type OrderTagState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const ORDER_TAG = (
  Details: React.ComponentType<ConditionTypeDetailsProps<OrderTagState>>,
): ConditionType<OrderTagState, Condition.OrderTag> => ({
  name: CONDITION_NAMES[Condition.ORDER_TAG],
  description(state) {
    return t("Order tags: {{tags}}", { tags: state.join(", ") });
  },
  Details(props: ConditionTypeDetailsProps<OrderTagState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model: Condition.OrderTag) {
    return orderTagFromModel(model);
  },
  toModel(state) {
    return { type: Condition.ORDER_TAG, tags: state };
  },
  valid(state) {
    return validateOrderTagCondition(state).valid;
  },
});
